<template>
    <div>
        <filter-main-layout
                filter-key="filter-main-wheel-auto"
                :select-fields="getSelectAndSlugSelectFields"
                :disabledValues="getDisabledValues"
                :checkboxes-fields="getCheckboxFields"
                :loading="loading"
                @change="filterValues"
                @submit="searchProducts"
                :reset-link="'/catalog/auto/wheel/all/all/all/all/all/all'"
        >
        </filter-main-layout>
    </div>
</template>

<script>
    import FilterMainLayout from './FilterMainLayout';
    import {mapActions, mapState, mapGetters} from "vuex";

    export default {
        name: "TheFilterMainWheelAuto",
        components: {FilterMainLayout},
        computed: {
          ...mapState('topParamAutoWheelModule', {
            paramInfo: 'paramInfo',
            loading: 'loading'
          }),
          ...mapGetters('topParamAutoWheelModule', {
            getSelectFields: 'getSelectFields',
            getSelectAndSlugSelectFields: 'getSelectAndSlugSelectFields',
            getCheckboxFields: 'getCheckboxFields',
            isCurrentPossible: 'isCurrentPossible',
            getDisabledValues: 'getDisabledValues',
          })
        },
        methods: {
          ...mapActions('topParamAutoWheelModule', {
            filterValues: 'filterValues',
            initializationFilter: 'initializationFilter',
            searchProducts: 'searchProducts'
          }),
        },
        mounted() {
          this.initializationFilter();
        }
    }
</script>

<style lang="scss">

</style>